import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function WelcomeLoader() {
  const navigate = useNavigate();

  useEffect(() => {
    const orig = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    // Auto-dismiss after 2 seconds and redirect to assets
    const timer = setTimeout(() => {
      document.body.style.overflow = orig;
      navigate("/assets");
    }, 2000);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = orig;
    };
  }, [navigate]);

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-gradient-to-b from-slate-950 to-slate-900">
      {/* Circular Loader */}
      <div className="w-12 h-12 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mb-4"></div>

      {/* Text */}
      <div className="text-white text-[10px] font-bold tracking-wider">
        FIXORIUM EXCHANGE
      </div>
    </div>
  );
}
